// extracted by mini-css-extract-plugin
module.exports = {"content":"index-module--content--23Tnl","wrapper":"index-module--wrapper--2YrzN","icon":"index-module--icon--q_AjM","button":"index-module--button--TxsfS"};